export default {
  title: 'הוספת הסכם חדש',
  form: {
    accumulationFrom: 'תאריך תחילת הסכם היקף',
    depositFrom: 'תאריך תחילת הסכם נפרעים',
    depositUntil: 'תוקף לעמלות נפרעים',
    accumulationUntil: 'תוקף לעמלות היקף',
  },
  comments: 'הערות',
};
